module.exports = __webpack_public_path__ + "static/img/book-kid.5d0d81f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/Wad/Wad-pics/book-kid.jpg
// module id = aW8E
// module chunks = 0